import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
}
const _hoisted_2 = { class: "bg-white space-y-6 rounded-lg shadow-lg p-6 max-w-md w-full" }
const _hoisted_3 = { class: "text-gray-700" }
const _hoisted_4 = { class: "flex justify-end" }




export default /*@__PURE__*/_defineComponent({
  __name: 'TaskCompletionBlockedModal',
  props: {
    show: { type: Boolean },
    reason: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "text-xl font-semibold mb-2" }, "Task Completion Blocked", -1)),
            _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.reason || "Completion requirements are not met."), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              class: "bg-primary hover:bg-primary/80 transition-all text-white px-4 py-1 rounded",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
            }, " Close ")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})